@if (users.length > 0) {
  <div class="flex -space-x-1" [ngClass]="containerClass">
    @for (user of getVisibleUsers(); track user.id) {
      <div
        [pTooltip]="tooltipContent"
        tooltipPosition="bottom"
        tooltipStyleClass="tooltip-extended-width"
        [ngClass]="getAvatarBgColor(user)"
        class="cursor-default inline-flex h-8 w-8 items-center justify-center rounded-full ring-2 ring-white shadow-lg relative">
        <span class="text-sm font-medium leading-none text-white">{{ user.initials }}</span>
      </div>

      <ng-template #tooltipContent>
        <p class="mb-0 font-medium">{{ user.name }}</p>
        <p class="mb-0">{{ user.email }}</p>
        <p class="mb-0">{{ user.roleText }}</p>
      </ng-template>
    }
    <div
      class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-bl-blue-light-200 ring-2 ring-white shadow-lg z-10"
      *ngIf="getNotVisibleUsersCount() > 0">
      <span class="text-sm font-medium leading-none text-bl-blue-500">+{{ getNotVisibleUsersCount() }}</span>
    </div>
  </div>
}
